import ApiInstance from "@/services/api/api.utils";

/**
 * Favorite Corporate
 */

export const getFavoriteCorpList = async (params) => {
  const res = await ApiInstance.get("/favourites/corporates", { params });
  return res;
};

export const postCreateOrDeleteFavoriteCorp = async (id) => {
  const res = await ApiInstance.post("/favourites/corporate", {
    corporate: id,
  });
  return res;
};

export const patchUpdateNotifyFavoriteCorporate = async (id) => {
  const res = await ApiInstance.patch(`/favourites/notify/corporate/${id}`);
  return res;
};

export const postDeleteMultipleFavoriteCorp = async (payload = []) => {
  const res = await ApiInstance.post("/favourites/deletes/corporates", {
    ids: payload,
  });
  return res;
};

/**
 * Favorite Job
 */

export const getFavoriteJobList = async (params) => {
  const res = await ApiInstance.get("/favourites/jobs", { params });
  // const formatAddressRes = {
  //   docs: res.docs?.map((item) => {
  //     return {
  //       ...item,
  //       job: {
  //         ...item.job,
  //         address: `${get(item, `job.city.name[${i18n.language}]`)}, ${get(
  //           item,
  //           `job.district.name[${i18n.language}]`
  //         )}`,
  //       },
  //     };
  //   }),
  // };
  // return formatAddressRes;
  return res;
};

export const postCreateOrDeleteFavoriteJob = async (id) => {
  const res = await ApiInstance.post("/favourites/job", {
    job: id,
  });
  return res;
};

export const postDeleteMultipleFavoriteJob = async (payload = []) => {
  const res = await ApiInstance.post("/favourites/deletes/jobs", {
    ids: payload,
  });
  return res;
};

/**
 * Favorite Personals
 */

export const getFavoriteTalentList = async (params) => {
  const res = await ApiInstance.get("/favourites/personals", { params });
  return res;
};

export const getFavoritePersonalList = async (params) => {
  const res = await ApiInstance.get("/favourites/corporate/personals", {
    params,
  });
  return res;
};

export const postCreateOrDeleteFavoritePersonal = async (id) => {
  const res = await ApiInstance.post("/favourites/personal", {
    user: id,
  });
  return res;
};
